var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.256 18.73H15.55c.715 0 1.295-.588 1.295-1.314v-6.57H3.96v6.57c0 .726.58 1.314 1.295 1.314Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C7D8",
    fillOpacity: 0.5,
    d: "M3.961 10.846h12.885v.962H3.961z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.319 7.77h-3.98C3.6 7.77 3 8.358 3 9.083v1.194c0 .315.26.57.58.57h13.84c.32 0 .58-.255.58-.57V9.083c0-.725-.6-1.313-1.34-1.313H8.32Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.282 7.77H7.914C6.105 7.52 3.891 5.941 4.43 4.274 4.92 2.758 6.392 1.991 7.896 2c2.123.011 2.673 4.225 2.673 4.225h.057S11.176 2.01 13.3 2c1.503-.009 2.975.758 3.465 2.275.54 1.667-1.675 3.246-3.483 3.494Zm1.58-4.239s-.067 2.074-3.01 3.622c0 0 .556-2.662 3.01-3.622Zm-8.503 0c2.452.96 3.009 3.622 3.009 3.622-2.943-1.548-3.009-3.622-3.009-3.622Z",
    fill: "url(#c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 10.219,
    y1: 9.775,
    x2: 10.57,
    y2: 19.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 10.57,
    y1: 7.953,
    x2: 10.991,
    y2: 11.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.598,
    y1: 2,
    x2: 10.598,
    y2: 7.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftGrayIcon);
export default __webpack_public_path__ + "static/media/gift-gray-icon.cecf54a83d50a046245d4214d6bd9783.svg";
export { ForwardRef as ReactComponent };